import {useI18n} from 'i18n/I18nContext'
import React, {useState} from 'react'
import LibraryAddIcon from '@mui/icons-material/LibraryAdd'
import ExampleTemplatesProvider from 'TemplateEditor/Layout/Sidebar/ExampleTemplates/ExampleTemplatesProvider'
import ExampleTemplateModal from 'TemplateEditor/Layout/Sidebar/ExampleTemplates/ExampleTemplateModal'
import OrganizationEventsListProvider from 'organization/ListEvents/providers/OrganizationEventsListProvider'

export function ExampleTemplates() {
  const {t} = useI18n()
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const toggleOpen = () => {
    setIsOpen((cur) => !cur)
  }

  return (
    <>
      <button
        type="button"
        className={'input__btn w-100 template-editor-designs-btn'}
        onClick={toggleOpen}
      >
        <LibraryAddIcon /> {t('templateEditor.designsButton')}
      </button>
      {isOpen && (
        <>
          <ExampleTemplatesProvider>
            <OrganizationEventsListProvider withTemplate={true}>
              <ExampleTemplateModal isOpen={isOpen} toggleOpen={toggleOpen} />
            </OrganizationEventsListProvider>
          </ExampleTemplatesProvider>
        </>
      )}
    </>
  )
}
